<footer>
    <div class="footer-content">
        <div class="footer-left">
            <span>All copyrights reserved</span>  
        </div>
        <div class="footer-right">
            <span>&#64;Chevron Corporation</span>  
            <!-- @if (environment()) {
                <span class="cvx-footer-environment">Env: {{ environment() }}</span>
            } -->
        </div>
    </div>
    <!-- <span>App Version: {{ appVersion() }}</span>
    <span>DB Version: {{ dbVersion() }}</span>
    <span>©{{ cvxYear }} Chevron Corporation</span>
    <span>Confidential Restricted</span>
    <span>
        Content Contact:
        <a target="_blank" href="{{ contentContactURL() }}">PFH Support</a>
    </span>
    <span>
        Technical Contact:
        <a target="_blank" href="{{ technicalContactURL() }}">PFH App Support</a>
    </span>
    <span>Last Sync: {{ pLastSync() }}</span>

    @if (environment()) {
        <span class="cvx-footer-environment">Env: {{ environment() }}</span>
    } -->

</footer>
